import RevealOnScroll from './RevealOnScroll';

export default function Services({ services }) {
  return (
    <section className="section services-section" id="services">
      <RevealOnScroll>
        <div className="section-header">
          <div className="vip-badge">
            <span className="dot" />
            Premium Hizmetler
          </div>
          <h2 className="section-title">HİZMETLERİMİZ</h2>
          <div className="section-ornament">
            <div className="line" />
            <div className="dot" />
            <div className="line" />
          </div>
        </div>
      </RevealOnScroll>
      <RevealOnScroll>
        <div className="services-grid">
          {services.map((s, i) => (
            <div className="service-item" key={s.id}>
              <span className="service-num">{String(i + 1).padStart(2, '0')}</span>
              <div className="service-left">
                <div className="service-icon">{s.icon}</div>
                <div>
                  <div className="service-name">{s.name}</div>
                  <div className="service-duration">{s.duration} dakika</div>
                </div>
              </div>
              <div className="service-price">{s.price_display}</div>
              <div className="service-shine" />
            </div>
          ))}
        </div>
      </RevealOnScroll>
    </section>
  );
}
